
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ProductCasesSelectionComponent } from './product-cases-selection/product-cases-selection.component';

@Component({
    selector: 'mnc-product-cases-lines-selection',
    templateUrl: './product-cases-lines-selection.component.html',
    imports: [ProductCasesSelectionComponent]
})
export class ProductCasesLinesSelectionComponent implements OnChanges {
  @Input() cases!: object[];
  @Input() filterable = true;
  @Input() multiselect = true;
  @Input() sortable = true;
  @Output() casesLinesSelected = new EventEmitter<object[]>();

  @ViewChild('productCasesSelectionTable', { static: true }) productCasesSelectionTable!: ProductCasesSelectionComponent;

  // Need to keep data from the product case widget in sync with this component
  ngOnChanges(changes: SimpleChanges): void {
    const cases = changes['cases']?.currentValue;

    if (cases) {
      this.cases = cases;
    }
  }

  handleCasesLinesSelected(data: object[]): void {
    this.casesLinesSelected.emit(data);
  }

  clearFilters(): void {
    this.productCasesSelectionTable.clearCaseTableFilters();
  }
}
